import { getToken, setApplyToken } from '@/utils/auth'
import { getUserInfoByToken } from '@/api/user'
import { Message } from 'element-ui'
import store from '..'

const user = {
  state: {
    userName: '',
    personCenter: false,
    tabIndex: 0,
    activeName: '/zcdx',
    token: getToken(),
    userInfo: {},
    userType: 0
  },

  mutations: {
    SetName: (state, userName) => {
      state.userName = userName
    },
    SetPersonCenter: (state, personCenter) => {
      state.personCenter = personCenter
    },
    SetTabIndex: (state, tabIndex) => {
      state.tabIndex = tabIndex
    },
    SetActiveName: (state, activeName) => {
      state.activeName = activeName
    },
    SetToken: (state, token) => {
      state.token = token;
    },
    SetUserInfo: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SetUserType: (state, userType) => {
      state.userType = userType;
    }
  }, 

  actions: {
    LOGIN({commit, state}) {
      getUserInfoByToken({token: state.token}).then(res => {
        commit('SetUserType', res.data.USER_TYPE);
        let userinfo = {};
        if (res.data.USER_TYPE == '1') {
          userinfo.companyName = res.data.userInfo.USER_NAME;
        } else {
          if (res.data.companyData && Object.keys(res.data.companyData).length != 0) {
            res.data.companyData.registrationDate = res.data.companyData.registerDate;
            if (res.data.companyData.companyZizhi) {
              res.data.companyData.companyZizhi = res.data.companyData.companyZizhi.split(',');
            }
            Object.assign(userinfo, res.data.loginData, res.data.companyData);
          } else {
            userinfo = res.data.loginData;
          }
          userinfo.registerDate = userinfo.registerDate?.substring(0, 10);
        }
        setApplyToken(res.data.token);
        console.log(userinfo,'userinfo')
        commit('SetUserInfo', userinfo);
        resolve();
        
      }).catch(err => {
        // reject()
      })
    } 
  }
}

export default user